"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = translate;
exports.format = format;
exports.getLocale = getLocale;
exports.initTranslator = initTranslator;
exports.interpolate = interpolate;
var _i18nReact = _interopRequireDefault(require("i18n-react"));
var _locale = require("date-fns/locale");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var userLocale = _locale.es;
function initTranslator(options) {
  if (Object.keys(options.messages).length === 0) {
    throw new Error('Any message set was provided');
  }
  switch (options.lang) {
    case 'en':
      userLocale = _locale.enUS;
      break;
    case 'es':
    default:
      userLocale = _locale.es;
      break;
  }
  _i18nReact["default"].setTexts(options.messages);
}
function getLocale() {
  return userLocale;
}
function interpolate(key, vars) {
  return _i18nReact["default"].interpolate(key, vars);
}
function format(key, vars) {
  return _i18nReact["default"].format(key, vars);
}
function translate(key, options) {
  return _i18nReact["default"].translate(key, options);
}